const wowApp = require('angular').module('wowApp.shop');

wowApp.service('SddDialogService', ['ContentOverlayService', 'LocalStorageService', 'BreakpointsService', require('./sdd-dialog-service')]);
wowApp.directive('wowSddDialog', ['SddDialogService', '$window', require('./sdd-dialog-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/sdd-dialog/index.js
 **/